import { Image } from 'antd';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import icon from '../img/newuser.png'
import { useAuth0 } from '@auth0/auth0-react';

export const NewUserPage =() => {

  const {
    user,
  } = useAuth0();

    return (
  <div className='text-center'>
    <Image
    width={'45vh'}
    src={icon}
    className='my-4'
    preview={false}
  />
    <h1 className='customTextColor my-2'>Cierpliwości weryfikacja trwa...</h1>
    <h5 className='customTextColor my-1'>
    {user?.email_verified ?
      <CheckCircleRoundedIcon color="success" className="m-1" fontSize="large"/>
      :<CancelRoundedIcon color="error" className="m-1" fontSize="large"/>}
      Potwierdzenie adresu email przez użytkownika
    </h5>
    <h5 className='customTextColor my-1'>
      {user?.dinneyroles.includes(process.env.REACT_APP_DINNEY_ROLE) ?
      <CheckCircleRoundedIcon color="success" className="m-1" fontSize="large"/>
      :<CancelRoundedIcon color="error" className="m-1" fontSize="large"/>}
      Weryfikacja użytkownika przez administratora
    </h5>
  </div>
    )
}